import styled from 'styled-components';

const Container = styled.div``;
const Nav = styled.nav`
  background: #000;
  height: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 999;
`;

const NavbarContainer = styled.div`
  justify-self: flex-start;
  display: flex;
  align-items: center;
  width: 100%;
  height: 67px;
  justify-content: space-between;
`;
const NavLogo = styled.div`
  width: 100%;
  max-width: 162px;
  align-items: center;
  margin: 0 20px;
  display: flex;
  img {
    width: 100%;
    height: 54px;
  }
`;

const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 1100px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-73%, 80%);
    cursor: pointer;
    svg {
      color: #ffffff;
    }
  }
`;
const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  cursor: pointer;
  padding-left: 13px;
  @media screen and (max-width: 1100px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 90vh;
    position: absolute;
    top: 53px;
    left: ${({ click }) => (click ? 0 : '-100%')};
    opacity: 1;
    transition: all 0.5s ease;
    background: #000;
  }
`;

const NavLink = styled.a`
  display: flex;
  padding: 6px;
  margin: 0 12px 0 0;
  text-decoration: none;
  color: #fff;
  text-transform: uppercase;
  transition: all ease-out 0.25s;
  font-weight: 700;
  letter-spacing: 1px;
  font-size: 13px;

  @media screen and (max-width: 1100px) {
    text-align: center;
    padding: 32px;
    width: 100%;
    display: table;

    &:hover {
      color: #4b59f7;
      transition: all 0.3s ease;
    }
  }
`;
const NavItem = styled.li`
  display: flex;
  height: 67px;
  align-items: center;

  &:hover {
    ${NavLink} {
      color: #1a5c80;
    }
  }
  @media screen and (max-width: 1100px) {
    width: 100%;
  }
`;
const LeftMenu = styled.div`
  display: flex;
  height: 67px;
`;
const RightMenu = styled.div`
  margin-right: 20px;
  Button {
    border: 1px solid #fff;
    border-radius: 50px;
    height: 28px;
    margin-left: 10px;
    font-weight: 700;
    padding: 8px;
    &:first-child {
      background-color: transparent;
      color: #fff;
    }
    &:nth-child(2) {
      background-color: white;
    }
    &:hover {
      background: #272742;
      color: #fff;
      border-color: transparent;
    }
  }
  @media screen and (max-width: 1100px) {
    padding-right: 34px;
  }
`;

export {
  Container,
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLink,
  RightMenu,
  LeftMenu,
};
